import React from 'react'
import { injectIntl } from "gatsby-plugin-intl"
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


class QandA extends React.Component {

    render() {
        const { intl } = this.props
        const QandAList = JSON.parse(intl.formatMessage({id:"QandAList"}))
        if(QandAList.length) {
            return (
                <div className="container box">
                    <div className="row box-header">
                        <h1>Q & A</h1>
                    </div>
                    <Accordion allowZeroExpanded>
                    { QandAList.map((QandA, i) => {
                        return (
                        <AccordionItem key={i}>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    {QandA.Q}
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                            <ul>
                                <li>
                                {QandA.A.split('<br>').map((A, j) => {
                                    return (
                                        <p key={(i * 100) * j}> {A} </p>
                                    )
                                })}
                                </li>
                            </ul>
                            </AccordionItemPanel>
                        </AccordionItem>
                        )
                    })}
                    </Accordion>
                </div>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default injectIntl(QandA)
